require ('./lib/polyfill');
import 'jquery';
import {devices, isBeforeOrEqualDevice, sizes} from './lib/config';
import {translate} from './lib/locales';
import { adaptCards,adaptSlider} from "./lib/tools";
import { initMapContact,initMapHome } from "./lib/map";

window.jQuery = window.$ = jQuery;
window.initMapContact = initMapContact;
window.initMapHome = initMapHome;


document.addEventListener("DOMContentLoaded", function (event) {
    require('owl.carousel');

    /**
     *  Smooth scrolling to page anchor on click
     */
    $("a[href*='#']:not([href='#'])").on('click', function(e) {
        if(
            location.hostname == this.hostname &&
            this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//, "")
        ){
            let anchor = $(this.hash);
            anchor = anchor.length ? anchor : $("[name="+this.hash.slice(1) + "]");

            if(anchor.length) {
                let display = $('.js-toggle-nav').css('display');

                if(display !== 'none') {
                    $('.js-toggle-nav').click();
                }

                $("html, body").animate({
                    scrollTop : (anchor.offset().top-100)
                }, 1500);

            }
        }
    });

    /**
     *  Open / Close responsive menu
     */
    const $menu = $('.Header__menuMobile ul');

    function openMenu() {
        $('.Backdrop').addClass('Backdrop__active');
        $('.js-toggle-nav').html('').html("<i class='fas fa-times'></i>");
        $('.Header__menuMobile ul').slideDown('normal');
    }

    function closeMenu() {
        $('.Backdrop').removeClass('Backdrop__active');
        $('.js-toggle-nav').html('').html("<i class='fas fa-bars'></i>");
        $('.Header__menuMobile ul').slideUp('normal');
    }
    $(document).mouseup(e => {
        let displayMenu = $menu.css('display');
        if (displayMenu != 'none' && !$menu.is(e.target) && $menu.has(e.target).length === 0) {
            closeMenu()
        }
    });

    $('.js-toggle-nav').on('click', function(e){
        let display = $('.Header__menuMobile ul').css('display');
        if(display === 'none') { openMenu();}
        else { closeMenu()}
    });


    /*
     * Owl carrousel
     */
    $('.Projects__articles.owl-carousel,.Projects__list.owl-carousel,.Service__slider.owl-carousel').on('initialized.owl.carousel', () => {
        $('.owl-dot').attr('role', 'presentation');
    });

    $('.Service__slider.owl-carousel').owlCarousel({
        items: 4,
        dots: true,
        responsive: {
            0: {items: 1},
            768: {items: 1},
            1199: {items: 1}
        },
        nav: false,
        autoWidth: false,
        autoHeight: true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:true,
        lazyLoad: true,
        loop: true
    });

    /**
     *  Owl carrousel on articles home
     */
    if(document.body.clientWidth <= sizes.xl)
    {
        $('.Projects__articles.owl-carousel').owlCarousel({
            items: 4,
            dots: true,
            responsive: {
                0: {items: 1},
                768: {items: 2},
                1199: {items: 3}
            },
            nav: false,
            autoWidth: false,
            autoHeight: true,
            autoplay:true,
            autoplayTimeout:5000,
            autoplayHoverPause:true,
            lazyLoad: true,
        });
    }

    /*
        Projects List filter
     */
    $('.Projects__filter').click(function(e) {
        let that = $(e.currentTarget),
            filter = that.data('filter'),
            filters = $('.Projects__filters .Projects__filter');

        filters.removeClass('active')
        that.addClass('active');

        if ($('.Projects__list.owl-carousel').hasClass('owl-carousel')) {
            $('.Projects__list.owl-carousel').trigger('destroy.owl.carousel');

            let html = "";
            $('.item__col').each( (index, el) => {
                let element = $(el),
                    content = element.html();
                element.remove();
                html += content;
            })

            $('.Projects__list').html(html)
        }

        let cards = $('.Projects__card');
        cards.each( (index, el) => {
            let card = $(el),
                cardFilter = card.data('filter'),
                cardFilterArr = cardFilter.split(',');

            card.show()

            if (filter !== 'ALL' && cardFilterArr.indexOf(filter.toString()) === -1) {
                card.hide()
            }
        });

       sliderProjects();
    })

    sliderProjects();
    adaptSlider();
    adaptCards();
    $(window).on('resize', adaptSlider);

    /*
        Projects List carousel
     */
    function sliderProjects() {
        /*if(document.body.clientWidth > sizes.sm) {*/
            $('.Projects__list.owl-carousel .item').each(function(index) {
                if ( index % 4 === 0) {
                    $(this).add($(this).next('.item')).add($(this).next('.item').next('.item')).add($(this).next('.item').next('.item').next('.item')).wrapAll('<div class="item__col" />');
                }
            });
        /*}*/

        $('.Projects__list.owl-carousel').owlCarousel({
            items: 4,
            dots: true,
            responsive: {
                0: {items: 1},
                768: {items: 3},
                1199: {items: 4}
            },
            nav: false,
            autoWidth: false,
            autoHeight: true,
            autoplay:true,
            autoplayTimeout:5000,
            autoplayHoverPause:true,
            lazyLoad: true,
        });
    }

    $('.js-contact-form').on('submit', (e) =>  {
        e.preventDefault();
        let $form = $(e.currentTarget);

        $.post (
            wp_obj.ajax_url, {
                'action': 'dpi_submit_contact_form',
                'firstname': $form.find('[name="firstname"]').val(),
                'lastname': $form.find('[name="lastname"]').val(),
                'email': $form.find('[name="email"]').val(),
                'phone': $form.find('[name="phone"]').val(),
                'object': $form.find('[name="object"]').val(),
                'message': $form.find('[name="message"]').val(),
                'captcha': grecaptcha.getResponse()
            },
            response => {
                if(response === "success") {
                    $form.trigger('reset');
                    contact_form_alert($form, 'success', translate('contact_success',[], 'fr'))
                } else if (response === "captcha") {
                    contact_form_alert($form, 'error', translate('contact_captcha',[], 'fr'));
                } else {
                    contact_form_alert($form, 'error', translate('contact_error', [], 'fr'));
                }
            }
        ).fail(() => {
            contact_form_alert($form, 'error', translate('contact_error', [], 'fr'));
        });

        return false
    });

    function contact_form_alert($form, type, message) {
        let $alert = $form.find('.Alert');

        if ($alert.length < 1) {
            $alert = $('<div></div>');
            $form.prepend($alert);
        }

        $alert.text(message);
        $alert.removeAttr('class');
        $alert.addClass('Alert');
        $alert.addClass('m-b-15');
        $alert.addClass('Alert--' + type);
        $alert.removeClass('hidden');

        $([document.documentElement, document.body]).animate({
            scrollTop: $alert.offset().top - 50
        }, 500)
    }

});

